export default "__VITE_ASSET__Bc3HBFH2__"